// extracted by mini-css-extract-plugin
export default {"general-label":"generalLabels_general-label__pBgZh","search-label":"generalLabels_search-label__VPblU","consistent-text-view":"generalLabels_consistent-text-view__64sT7"};